
import {computed, defineComponent} from "vue";
import useStore from "@/composables/useStore";
import {useI18n} from "vue-i18n";
import useDiamondProperties from "@/composables/useDiamondProperties";

export default defineComponent({
    name: "SelectedDiamondGiaCertificate",
    setup() {
        const store = useStore();
        const selectedDiamond = computed(
            () => store.state.userSelection.diamond
        );

        const {certificateUrl} = useDiamondProperties(selectedDiamond);

        return {
            ...useI18n(),
            selectedDiamond,
            certificateUrl
        };
    }
});
